import { studentDisadvantageLevel } from './studentContext/studentDisadvantageLevel'
import { totalLevel } from './studentContext/totalLevel'
import { contextOverview } from './summaryContext/contextOverview'
import { SATScoreInHSContext } from './summaryContext/SATScoreInHSContext'
import { DECILE, ReadStudentContext, ReadDIQuery } from '../types'

interface CreateChartProps {
  overrideChartUnitsPref: boolean
  tempChartUnitsSelection: string
  instPrefChartDisplayUnits: string
  showNational: boolean
  readStudentContext: ReadStudentContext
  readDIQuery: ReadDIQuery
  isInteractive: boolean
}

export const createChart = (chartProps: CreateChartProps) => {
  const {
    overrideChartUnitsPref,
    tempChartUnitsSelection,
    instPrefChartDisplayUnits,
    showNational,
    readStudentContext,
    readDIQuery,
    isInteractive,
  } = chartProps
  let finalChartDisplayUnits
  if (overrideChartUnitsPref) {
    finalChartDisplayUnits = tempChartUnitsSelection
  } else {
    finalChartDisplayUnits = instPrefChartDisplayUnits
  }

  let studentDisadvantageData
  if (!showNational) {
    studentDisadvantageData = {
      nh_college_access: readStudentContext.st_a_nh_college_access,
      hs_college_access: readStudentContext.st_a_hs_college_access_ptile,
      nh_family_ptile: readStudentContext.st_a_nh_family_ptile,
      hs_family_ptile: readStudentContext.st_a_hs_family_ptile,
      nh_medfaminc_ptile: readStudentContext.st_a_nh_medfaminc_ptile,
      hs_medfaminc_ptile: readStudentContext.st_a_hs_medfaminc_ptile,
      nh_housing_ptile: readStudentContext.st_a_nh_housing_ptile,
      hs_housing_ptile: readStudentContext.st_a_hs_housing_ptile,
      nh_educ_ptile: readStudentContext.st_a_nh_educ_ptile,
      hs_educ_ptile: readStudentContext.st_a_hs_educ_ptile,
      nh_crime_ptile: readStudentContext.st_a_nh_crime_ptile,
      hs_crime_ptile: readStudentContext.st_a_hs_crime_ptile,
      nh_overrall_ptile: readStudentContext.st_a_nh_overrall_ptile,
      hs_overrall_ptile: readStudentContext.st_a_hs_overrall_ptile,
    }
  } else {
    studentDisadvantageData = {
      nh_college_access: readStudentContext.a_nh_college_access,
      hs_college_access: readStudentContext.a_hs_college_access,
      nh_family_ptile: readStudentContext.a_nh_family_ptile,
      hs_family_ptile: readStudentContext.a_hs_family_ptile,
      nh_medfaminc_ptile: readStudentContext.a_nh_medfaminc_ptile,
      hs_medfaminc_ptile: readStudentContext.a_hs_medfaminc_ptile,
      nh_housing_ptile: readStudentContext.a_nh_housing_ptile,
      hs_housing_ptile: readStudentContext.a_hs_housing_ptile,
      nh_educ_ptile: readStudentContext.a_nh_educ_ptile,
      hs_educ_ptile: readStudentContext.a_hs_educ_ptile,
      nh_crime_ptile: readStudentContext.a_nh_crime_ptile,
      hs_crime_ptile: readStudentContext.a_hs_crime_ptile,
      nh_overrall_ptile: readStudentContext.a_nh_overrall_ptile,
      hs_overrall_ptile: readStudentContext.a_hs_overrall_ptile,
    }
  }

  const isDecile = finalChartDisplayUnits === DECILE
  contextOverview(readStudentContext, readDIQuery, isDecile)
  totalLevel(studentDisadvantageData, { showNational, isInteractive })
  studentDisadvantageLevel(studentDisadvantageData, { showNational, isInteractive })
  SATScoreInHSContext(readStudentContext)

  // this is for common app, so that we know the very last thing that happens
  // document.getElementById('chart-applicant-id-header').classList.add('waitForLoadD3')
  const div = document.createElement('div')
  div.className = 'waitForLoadD3'
  div.id = 'waitForLoadD3'
  div.innerHTML = ''
  document.body.appendChild(div)
}
